import React, { Fragment } from 'react'
import { Card, Grid } from 'semantic-ui-react'
import { STATS_UPDATE as STATS_UPDATE_ROUTE } from './routes'
import PropTypes from 'prop-types'

const PlaySelectionGrid = ({
  history,
  location: { state },
  match: {
    params: { gameId: id }
  }
}) => {
  const buttonStyle = {
    margin: 0,
    borderRadius: 0,
    lineHeight: 7,
    color: 'black',
    fontWeight: 'bolder'
  }

  const options = [
    ['Pass Left', 'Pass Mid', 'Pass Right'],
    ['Run Left', 'Run Mid', 'Run Right'],
    ['Kick']
  ]

  const buttons = options.map((row, rowIndex) => {
    const rowButtons = row.map((play, colIndex) => {
      return (
        <Grid.Column style={{ padding: 0 }} key={colIndex}>
          <Card
            fluid
            style={buttonStyle}
            onClick={() =>
              history.replace(STATS_UPDATE_ROUTE.format(id), {
                ...state,
                play: {
                  data: [rowIndex, colIndex],
                  text: play
                }
              })
            }
          >
            <Card.Content textAlign="center">{play}</Card.Content>
          </Card>
        </Grid.Column>
      )
    })
    return (
      <Grid.Row
        columns={'equal'}
        key={rowIndex}
        style={{
          padding: 0
        }}
      >
        {rowButtons}
      </Grid.Row>
    )
  })

  return <Fragment>{buttons}</Fragment>
}

PlaySelectionGrid.propTypes = {
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired
}

export default PlaySelectionGrid



// WEBPACK FOOTER //
// ./src/components/Controller/PlaySelectionGrid.jsx